module.exports = __webpack_public_path__ + "pic/55.cec936d8.png";